<template>
    <v-card flat>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title
                >{{ $route.params.clientId === "new" ? "Add new" : activeClient.name | t }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important;">
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <client-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <client-codes-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <contacts-info-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import ClientInfoEditTab from "@/pages/export-clients/clients-tab-items/client-info-edit-tab";
import Store from "@/store";
import { mapActions, mapState } from "vuex";
import ContactsInfoEditTab from "@/pages/export-clients/clients-tab-items/contacts-info-edit-tab";
import ClientCodesEditTab from "@/pages/export-clients/clients-tab-items/client-codes-edit-tab";

export default {
    name: "client-edit",
    components: { ClientCodesEditTab, ContactsInfoEditTab, ClientInfoEditTab },
    data() {
        return {
            tab: 0,
            tabs: ["Client info", "Codes", "Contacts info"]
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.clientId === "new") {
            await this.getFrequentlyUsedQueries({ users: true });
            await Store.commit("ExportClientStore/addNewClient");
        } else {
            await Store.dispatch("ExportClientStore/getClientData", this.$route.params.clientId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("ExportClientStore", ["activeClient", "loadingClientData", "errorMessage", "requestSuccess"])
    },
    watch: {
        requestSuccess(val) {
            if (val === true) {
                this.$router.push({
                    name: "export-client-list"
                });
            }
        }
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        closeDrawer() {
            this.$router.push({ name: "export-client-list" });
        },
        submitEdit() {
            Store.dispatch("ExportClientStore/submitClientUpdate", this.activeClient);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (
                document.activeElement.tagName !== "INPUT" &&
                document.activeElement.tagName !== "TEXTAREA" &&
                document.activeElement !== document.querySelector(".ProseMirror-focused") //tipTap editor
            ) {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        }
    }
};
</script>

<style scoped></style>
